export default "__VITE_ASSET__vUIUQK0w__"